import type { ReactNode } from 'react'
import { AdminOverviewProvider } from './admin-overview-provider'
import { CompletionChart } from './completion-chart'
import { InterviewsEmbed } from './interviews-embed'
import { PaceVsPlan } from './pace-vs-plan'
import { RiskFlags } from './risk-flags'
import { TrackHealth } from './track-health'

function OverviewContent({ clientId }: { clientId: string }): ReactNode {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,2fr)_minmax(18rem,1fr)]">
        <CompletionChart />
        <TrackHealth />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <PaceVsPlan />
        <RiskFlags />
      </div>
      <InterviewsEmbed clientId={clientId} />
    </div>
  )
}

export function OverviewTab({ clientId }: { clientId: string }): ReactNode {
  return (
    <AdminOverviewProvider clientId={clientId}>
      <OverviewContent clientId={clientId} />
    </AdminOverviewProvider>
  )
}
